import { productIdFormat } from "@redotech/redo-model/ids";
import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const AdjustmentReportRowSchema = z.object({
  productId: productIdFormat.schema,
  productName: z.string(),
  quantityStart: z.number(),
  quantityEnd: z.number(),
  valueStart: z.number().nullable(),
  valueEnd: z.number().nullable(),
  currency: z.string().nullable(),
});
export type AdjustmentReportRow = z.infer<typeof AdjustmentReportRowSchema>;

export const adjustmentReportSortKeySchema = createEnum([
  "productName",
  "quantityStart",
  "quantityEnd",
  "valueStart",
  "valueEnd",
]);

export const getAdjustmentReport = {
  name: "getAdjustmentReport" as const,
  input: z.object({
    page: z.number().int().min(0).default(0),
    pageSize: z.number().int().min(1).max(1000),
    search: z.string().optional(),
    sortBy: adjustmentReportSortKeySchema.optional(),
    sortDirection: createEnum(["asc", "desc"]).optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({ rows: z.array(AdjustmentReportRowSchema) }),
};
